import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";

const SocialShare = {

	getWindowDimension: function() {
		var windowwidth= 700, windowheight= 500;
		var left = (window.screen.width / 2) - ((windowwidth/ 2) + 10);
		var top = (window.screen.height / 2) - ((windowheight / 2) + 50);
		var windowDim = "status=no,height=" + windowheight + ",width=" + windowwidth + ",resizable=yes,left="
			+ left + ",top=" + top + ",screenX=" + left + ",screenY="
			+ top + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";
		return windowDim;
	},

	openWindow: function(url, title) {
		window.open(url, title,  this.getWindowDimension());
	}

};

export { SocialShare };



// WEBPACK FOOTER //
// ./Javascript/core/classes/socialshare/social.share.class.js